import { SupportedFileType } from "../../file";
export const MAX_CHARACTERS = 1000;
export const PARAGRAPH_TEXT_HEADER_COMMON = 'Upload an image with the size of ';
export const PARAGRAPH_TEXT_HEADER_COMMONPT = ' for the best results.';
export const BRANDED_NOTIFICATION_ALIGNMENT = 'Alignment';
export const PRIMARY_HEADER_LOGO = 'Primary Header Logo';
export const SECONDARY_HEADER_GRAPHIC = 'Secondary Header Graphic';
export const PRIMARY_HEADER_LOGO_RESOLUTION = '670px x 80px';
export const SECONDARY_HEADER_GRAPHIC_RESOLUTION = '100px x 100px';
export const HEADER_LOGO_ALT_TEXT = 'Header Logo';
export const SECONDARY_GRAPHIC_ALT_TEXT = 'Header Graphic';
export const CANCEL_EDIT_BUTTON = 'brandedNotification-btnCancelEditContent';
export const SAVE_BUTTON = 'brandedNotification-btnSaveContent';
export const CONFIRMATION_MODAL_TEXT_CONTENT = 'Before you go, do you want to save your changes?';
export const WARNING_TEMPLATE_MODAL_SAVE_BUTTON_ID = 'brandedNotificationSaveButton';
export const WARNING_TEMPLATE_MODAL_STAY_HERE_BUTTON_ID = 'brandedNotificationStayHereButton';
export const WARNING_TEMPLATE_MODAL_DONT_SAVE_BUTTON_ID = 'brandedNotificationDontSaveButton';
export const _ALIGNED = '_ALIGNED';
export const PRIMARY_HEADER_LOGO_ALIGNMENT = 'primaryHeaderLogoAlignment';
export const PRIMARY_HEADER_LOGO_KEY = 'primaryHeaderLogo';
export const SECONDARY_HEADER_LOGO_ID = 'secondaryHeaderGraphic';
export const AVATAR = 'Avatar';
export const ID_AVATAR_IMAGE = 'avatarImage';
export const AVATAR_IMAGE = 'avatarImage';
export const AVATAR_IMAGE_RESOLUTION_TEXT = '118px x 117px';
export const GENERAL_APPLICATION = 'General Application';
export const UPLOAD_SUCCESSFUL_PAGE_HEADING = 'Upload Successful Page';
export const STYLE = 'style';
export const REQUEST_PHOTOS = 'RP';
export const WELCOME = 'WELCOME';
export const UPLOAD = 'UPLOAD';
export const ESTIMATE_UPLOAD = 'ESTIMATEUPLOAD';
export const INHERIT = 'inherit';
export const ID_PREFIX_HTML_VIEWER = 'html_viewer';
export const APPLICATION_CONTENT = 'content';
export const GENERAL_CONTENT = 'general';
export const NONE = 'NONE';
export const API_PREFIX = 'branded-notification-orch-api/v1/companies/';
export const CATEGORIES = 'Categories';
export const MAX_HOURS_PBE_LINK_EXPIRATION = 99999;
export const EN_US = 'en-US';
export const ID_PREFIX = 'brandedNotification';
export const COMMENT_TEXT_MAX_CHARACTER = 200;
export const ADD_COMMENTS_PLACEHOLDER = 'Add Comments...';
export const PERSONA = 'Persona';
export const ENABLE_ADDITIONAL_OPTION = 'shouldEnableAdditionalOption';
export const ENABLE_IMAGE_QUALITY_ASSESSMENT = 'shouldEnableImageQualityAssessment';
export const SHOULD_ALLOW_MITCHELL_INETLLIGENT = 'shouldAllowMitchellIntelligentPhotoCapture';
export const ENABLE_OCR_IMAGE_TEXT_DECODE = 'shouldEnableOCRImageTextDecode';
export const SHOULD_ALLOW_DOWNLOAD_IMAGE = 'shouldAllowDownloadImage';
export const SHOULD_ALLOW_VIN_DECODE = 'shouldAllowVinDecode';
export const REDIRECT_RADIO = 'REDIRECT_RADIO';
export const ESTIMATOR_VIN_RADIO_OPTIONS = [
    {
        id: `${ID_PREFIX}_estimator_configuration_key_vinOption_vin`,
        label: 'VIN-Windshield',
        value: 'VIN'
    },
    {
        id: `${ID_PREFIX}_estimator_configuration_key_vinOption_vinSticker`,
        label: 'VIN Sticker-Door Jamb',
        value: 'VIN_STICKER'
    }
];
export const SUPPORTED_FILE_TYPES = [
    SupportedFileType.PNG,
    SupportedFileType.JPEG,
    SupportedFileType.JPG,
    SupportedFileType.GIF
];
export const RADIO_BUTTONS = [
    {
        id: 'brandedNotificationLeftAligned',
        label: 'Left-Aligned',
        value: 'left'
    },
    {
        id: 'brandedNotificationCenterAligned',
        label: 'Center-Aligned',
        value: 'center'
    },
    {
        id: 'brandedNotificationRightAligned',
        label: 'Right-Aligned',
        value: 'right'
    }
];
export const EmailStyleConstant = {
    GET_STARTED_TAKE_PHOTO_BUTTON_ALT_TEXT: 'Get Started / Take Photos Button Alt Text',
    SUBJECT: 'Subject',
    SECOND_HEADER: 'Second Header',
    BODY1: 'Body 1',
    BODY2: 'Body 2',
    RICH_TEXT_LABEL: 'Footer',
    MAIN_CONTENT: 'mainContent',
    SECONDARY_CONTENT: 'secondaryContent',
    EMAIL_SUBJECT: 'emailSubject',
    SECONDARY_HEADER: 'secondaryHeader',
    GET_STARTED_BUTTON_TEXT: 'getStartedButtonText',
    GET_STARTED_BUTTON_ALT_TEXT: 'getStartedButtonAltText',
    FOOTER: 'footer',
    REQUEST_PHOTOS: 'RP',
    WELCOME: 'WELCOME',
    EMAIL: 'EMAIL',
    WEBSITELINK: 'Website Link',
    WEBSITE_LINK: 'websiteLink',
    ID_WEBSITE_LINK: 'idWebsiteLink',
    ID_MAIN_CONTENT_NOTE: 'idMainContent',
    WEBSITE_LINK_PLACE_HOLDER: 'Enter a website link',
    WEBSITE_LINK_NOTE: 'Note: Contact the product team for additional set up if the carrier is enabling a third level URL.',
    WEBSITE_LINK_EXAMPLE: 'Example third level URL',
    WEBSITE_LINK_EXAMPLE_URL: 'http://testcompany.mymitchell.com/photocapture/',
    MAIN_CONTENT_NOTE: 'Note: Text 1 will display before the website link.'
};
export const ApplicationContentIds = {
    PRIVACY: 'privacy',
    TERMS_OF_USE: 'termsOfUse',
    PBE_HEADER: 'pbeHeader',
    GPC_HEADER: 'gpcHeader',
    UPLOAD_SUCCESSFUL_MESSAGE: 'uploadSuccessfulMessage',
    AUTO_REDIRECTION_URL: 'autoRedirectionUrl',
    REPAIR_ASSIGNMENT_SUCCESSFUL_MESSAGE: 'repairAssignmentSuccessfulMessage',
    POST_UPLOAD_REVISIT_MESSAGE: 'postUploadRevisitMessage',
    REDIRECTION_BUTTON_TEXT: 'redirectionButtonText'
};
export const ApplicationContentLabels = {
    LINKS: 'Links',
    APPLICATION_HEADER: 'Application Header',
    PRIVACY: 'Privacy',
    TERMS_OF_USE: 'Terms of Use',
    PBE_HEADER: 'Photo-based Estimating Header',
    GPC_HEADER: 'Generic Photo Capture Header',
    UPLOAD_SUCCESSFUL_MESSAGE: 'Upload Successful Message',
    AUTO_REDIRECTION_URL: 'Auto Redirection Url',
    REPAIR_ASSIGNMENT_SUCCESSFUL_MESSAGE: 'Repair Assignment Successful Message',
    POST_UPLOAD_REVISIT_MESSAGE: 'Post Upload Revisit Message',
    REDIRECTION_BUTTON_TEXT: 'Redirection Button Text'
};
export const RICHTEXT_EDITOR_DEFAULT_VALUE = '<p><br></p>';
export const FILTER_RECIPIENT_OPTIONS = [
    {
        personaProfile: '0',
        value: '0',
        label: 'Select'
    },
    {
        personaProfile: '1',
        value: '1',
        label: 'Base Template'
    },
    {
        personaProfile: 'CLAIMANT',
        value: 'Claimant',
        label: 'Claimant'
    },
    {
        personaProfile: 'INSURED',
        value: 'Insured',
        label: 'Insured'
    },
    {
        personaProfile: 'OWNER',
        value: 'Owner',
        label: 'Owner'
    },
    {
        personaProfile: 'SALVAGE_PROVIDER',
        value: 'Salvage Provider',
        label: 'Salvage Facility'
    },
    {
        personaProfile: 'STAFF_APPRAISER',
        value: 'Staff Appraiser',
        label: 'Staff Appraiser'
    },
    {
        personaProfile: 'PROGRAM_SHOP',
        value: 'Program Shop',
        label: 'Network Shop'
    },
    {
        personaProfile: 'NON_PROGRAM_SHOP',
        value: 'Non-Program Shop',
        label: 'Non-Network Shop'
    },
    {
        personaProfile: 'TOW',
        value: 'Tow',
        label: 'Towing'
    },
    {
        personaProfile: 'POLICY_HOLDER',
        value: 'Policy Holder',
        label: 'Policy Holder'
    },
    {
        personaProfile: 'FAMILY_RELATIVE',
        value: 'Family/Relative',
        label: 'Family/Relative'
    },
    {
        personaProfile: 'INDEPENDENT_APPRAISER',
        value: 'Independent Appraiser',
        label: 'Independent Appraiser'
    },
    {
        personaProfile: 'AGENT',
        value: 'Agent',
        label: 'Agent'
    }
];
export const LANGUAGE_MAP = {
    'English (US)': 'en-US',
    'Français (Canada)': 'fr-CA',
    'Español (España)': 'es-ES'
};
export const InputTextFields = [
    ApplicationContentIds.PRIVACY,
    ApplicationContentIds.TERMS_OF_USE,
    ApplicationContentIds.PBE_HEADER,
    ApplicationContentIds.GPC_HEADER,
    ApplicationContentIds.AUTO_REDIRECTION_URL,
    ApplicationContentIds.REDIRECTION_BUTTON_TEXT
];
export const VEHICLE_INFORMATION_CHILD_KEYS = [
    'shouldCaptureVin',
    'shouldCaptureLicensePlate',
    'shouldCaptureOdometerMileage'
];
export const FOUR_CORNERS_CHILD_KEYS = [
    'shouldCaptureFrontLeft',
    'shouldCaptureFrontRight',
    'shouldCaptureRearLeft',
    'shouldCaptureRearRight'
];
//# sourceMappingURL=BrandedNotificationConstant.js.map